module.exports = __webpack_public_path__ + "static/media/BF.5219d0a9.png";